module.exports = __webpack_public_path__ + "static/img/ikonaTablice-ON.f1c2c6b7.png";